"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SickLeaveDoctorDetails_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SickLeaveDoctorDetails_Factory = /** @class */ (function () {
    function SickLeaveDoctorDetails_Factory() {
    }
    SickLeaveDoctorDetails_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            BirthDate: model.BirthDate,
            Email: model.Email,
            IdIqamaNumber: model.IdIqamaNumber,
            IsCitizen: model.IsCitizen,
            MobileNumber: model.MobileNumber,
        };
        return result;
    };
    SickLeaveDoctorDetails_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            BirthDate: model.BirthDate,
            Email: model.Email,
            IdIqamaNumber: model.IdIqamaNumber,
            IsCitizen: model.IsCitizen,
            MobileNumber: model.MobileNumber,
        };
        return result;
    };
    return SickLeaveDoctorDetails_Factory;
}());
exports.SickLeaveDoctorDetails_Factory = SickLeaveDoctorDetails_Factory;
